import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule } from '@angular/forms';
import { ShareButtonModule } from 'ngx-sharebuttons/button';

import { IconsRegistry } from '@p1/libs/icons/src/lib/registry/icons.registry';
import {
  iconBin,
  iconComment,
  iconCommentEdit,
  iconEdit,
  iconInfoCircle,
  iconShare,
  iconLink
} from '@p1/libs/icons';

import { SharedModule } from '../shared/shared.module';
import { SocialShareButtonsModule } from '../social-share-buttons/social-share-buttons.module';
import { WatchlistsListComponent } from './watchlists-list/watchlists-list.component';
import { WatchlistPreviewComponent } from './watchlist-preview/watchlist-preview.component';
import { WatchlistCreateDialogComponent } from './watchlist-create-dialog/watchlist-create-dialog.component';
import { WatchlistUpdateDialogComponent } from './watchlist-update-dialog/watchlist-update-dialog.component';
import { WatchlistContentListComponent } from './watchlist-content-list/watchlist-content-list.component';
import { WatchlistRemoveElementDialogComponent } from './watchlist-remove-element-dialog/watchlist-remove-element-dialog.component';
import { WatchlistCommentElementDialogComponent } from './watchlist-comment-element-dialog/watchlist-comment-element-dialog.component';
import { WatchlistRemoveDialogComponent } from './watchlist-remove-dialog/watchlist-remove-dialog.component';
import { WatchlistShareDialogComponent } from './watchlist-share-dialog/watchlist-share-dialog.component';


@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    RouterModule,
    ReactiveFormsModule,
    ShareButtonModule,
    SocialShareButtonsModule
  ],
  declarations: [
    WatchlistsListComponent,
    WatchlistPreviewComponent,
    WatchlistCreateDialogComponent,
    WatchlistUpdateDialogComponent,
    WatchlistRemoveDialogComponent,
    WatchlistRemoveElementDialogComponent,
    WatchlistCommentElementDialogComponent,
    WatchlistContentListComponent,
    WatchlistShareDialogComponent
  ],
  exports: [
    WatchlistsListComponent,
    WatchlistPreviewComponent,
    WatchlistCreateDialogComponent,
    WatchlistUpdateDialogComponent,
    WatchlistRemoveDialogComponent,
    WatchlistRemoveElementDialogComponent,
    WatchlistCommentElementDialogComponent,
    WatchlistContentListComponent,
    WatchlistShareDialogComponent
  ]
})
export class WatchlistsSharedModule {
  constructor(private _iconsRegistry: IconsRegistry) {
    this._iconsRegistry.registerIcons([
      iconBin,
      iconComment,
      iconCommentEdit,
      iconEdit,
      iconInfoCircle,
      iconShare,
      iconLink
    ]);
  }
}
